import axios from 'axios'
import { Toast } from 'vant'

const service = axios.create({
  headers: {
    'content-type': 'application/json'
  },
  timeout: 100000 // request timeout
})
service.interceptors.request.use(
  config => {
    // 从本地存储获取token
    const token = sessionStorage.getItem('token')
    console.log('request:',token)
    // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhc3NvY19pZCI6MTM1LCJ1c2VyX2lkIjoxNzQyNjYsImxvZ2luX3R5cGUiOiJtZW1iZXJfbG9naW4iLCJ1c2VyX25hbWUiOiIxMzIxNDg2NjMxNiIsImV4cCI6MTY2NzkwODE2NSwiYXV0aG9yaXRpZXMiOlsiUk9MRV9BQ1RJVklUSV9BRE1JTiIsIlJPTEVfbWVtYmVyIiwiUk9MRV9BQ1RJVklUSV9VU0VSIiwiR1JPVVBfbWVtYmVyVGVhbSJdLCJ1c2VyX2NoX25hbWUiOiLlkLTkvJ_ms6IifQ.dMkz-CBGsqrRlWJnHiqf0AdlZlgpolFLDaLt3fGmyYujd_lGYYsdOD2Tj92NrMIC5Q2aK6dZgM53oJ0Pb7AH-0Px9Fn7kcJCl4xb_fXOp6uUd7XyHqozUPdXWy8GrtRtcuCnO1LmlnNfYmRDFcHOC8Rj2IjxwOO3gaEFyq3VroJx4NVVysnSdNWVLbB9DUrnWBqz5v26dFEKDQWJ4QKLz2cfQ69X16ibNieyj0JN3oG7rL-7IuRCWq2M6q5g8WODdH1k2bTuGv8bA_B4crAIvYdOWuKU5xJlcUM5hibejeeJitdVUXHU7ghVNjZjQm5PBba2zuw51gFkmh03oEwsQA'
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  
  response => {
    const res = response.data
    if (res.code !== 200) {
      Toast.fail(res.message)
      return res
      // return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    
    return Promise.reject(error)
  }
)
export default service


// WEBPACK FOOTER //
// ./src/api/request.js